const TRIGGER = 0.4;

document.querySelectorAll('section.scroller').forEach(scroller => {
	const images = [...scroller.querySelectorAll('.images img')];
	const steps = [...scroller.querySelectorAll('.step')];
	if (!images.length || !steps.length) return;

	const set = i => images.forEach(img =>
		img.classList.toggle('active', img.dataset.item <= i)
	);

	let observer;

	const init = () => {
		observer?.disconnect();

		const y = window.innerHeight * (1 - TRIGGER);

		observer = new IntersectionObserver(entries => {
			entries.forEach(e => {
				if (!e.isIntersecting) return;
				set(e.target.closest('.step').dataset.item);
			});
		}, {
			rootMargin: `-${y}px 0px -${window.innerHeight - y - 1}px 0px`
		});

		steps.forEach(s => {
			const h = s.querySelector('.headline');
			h && observer.observe(h);
		});
	};

	set(steps[0].dataset.item);
	init();

	window.addEventListener('resize', init);
});
